var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-box",
    {
      attrs: {
        title: "Add/edit video",
        icon: "image",
        "is-processing": _vm.isProcessing,
        "is-visible": _vm.isVisible,
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "a",
                {
                  staticClass: "gfu-link gfu-link--accent",
                  attrs: { href: "", "data-qa": "modal-button:Cancel" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("cancel")]
              ),
              _vm._v(" "),
              _c(
                "icon-base-button",
                {
                  attrs: {
                    size: "default",
                    width: "compact",
                    "text-transform": "none",
                    wide: true,
                    bold: true,
                    theme: "accent",
                    icon: "check",
                    enabled: !_vm.isProcessing,
                    "data-qa": "modal-button:Save",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Save")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("text-field", {
        attrs: {
          "display-name": "Video URL",
          description: "We support Youtube, Dailymotion, Vimeo and Twitch.",
          name: "model.url",
          "data-qa": "modal-field:VideoUrl",
        },
        model: {
          value: _vm.model.url,
          callback: function ($$v) {
            _vm.$set(_vm.model, "url", $$v)
          },
          expression: "model.url",
        },
      }),
      _vm._v(" "),
      _c("image-field", {
        attrs: {
          name: "model.imageUrl",
          "display-name": "Custom thumbnail",
          description:
            "Thumbnail will appear only for Dailymotion, Vimeo and Twitch clips.",
          "format-list": _vm.formatList,
          "min-width": _vm.minWidth,
          "min-height": _vm.minHeight,
          ratio: _vm.ratio,
          "upload-api-action": _vm.uploadApiAction,
          "thumb-url": _vm.model.imageUrl,
          "image-class": "gfu-field-image__image--expanded",
          "data-qa": "modal-field:ImageField",
        },
        on: { "image-uploaded": _vm.onImageUploaded, error: _vm.handleError },
        model: {
          value: _vm.model.imageUrl,
          callback: function ($$v) {
            _vm.$set(_vm.model, "imageUrl", $$v)
          },
          expression: "model.imageUrl",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }